module.exports = __webpack_public_path__ + "static/media/12-2.8b697a86.mp3";